// App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import logoDR from "./img/logo-dataregion.png"; // usa tu logo real
import "./index.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <Protected>
              <DashboardLayout>
                <Dashboard />
              </DashboardLayout>
            </Protected>
          }
        />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

function DashboardLayout({ children }) {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const roleLabel =
    user.role === "admin"
      ? "Administrador"
      : user.role === "institution"
      ? "Institución"
      : "Usuario";

  const userTypeLabel = user.userType ? ` • ${user.userType}` : "";

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/login";
  };

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header-left">
          <img src={logoDR} alt="DataRegión" className="app-header-logo" />
        </div>

        <div className="app-header-right">
          <div className="app-user">
            <div className="app-user-name">{user.name || "Usuario"}</div>
            <div className="app-user-meta">
              {roleLabel} ({user.role}){userTypeLabel}
            </div>
          </div>

          <button className="app-logout-btn" onClick={handleLogout}>
            Cerrar sesión
          </button>
        </div>
      </header>

      <div className="app-body">{children}</div>

      <footer className="app-footer">
        © {new Date().getFullYear()} DataRegión. Todos los derechos reservados.
      </footer>
    </div>
  );
}

function Protected({ children }) {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export default App;
